// store — am. MyStore seller product manager and the Submit content-upload page.
export default {
  storeErrNameRequired: 'የምርት ስም ማስገባት አለበት።',
  storeErrCategoryRequired: 'ምድብ ማስገባት አለበት።',
  storeErrPriceInvalid: 'ዋጋ ከዜሮ በላይ መሆን አለበት።',
  storeErrStockInvalid: 'ክምት ከዜሮ በላይ ወይም ከዜሮ ጋር እኩል መሆን አለበት።',
  storeErrImageRequired: 'እባክዎ ቢያንስ አንድ የምርት ምስል ያክሉ።',
  storeErrMaxPhotos: 'ከ5 በላይ ፎቶዎች መጠበቅ አይቻልም።',
  storeSaveFailed: 'ማስቀመጥ አልተቻለም።',
  storeDeleteFailed: 'ሰርዝ አልተቻለም።',
  storeSalePrice: 'የግዢ ዋጋ (ETB) — ቅናሽ ካልፈለግዎ ባዶ ይተውሉ',
  storeSelectCategory: 'ምድብ ይምረጡ...',
  storeSubcategory: 'ንዑስ ምድብ',
  storeSelectSubcategory: 'ንዑስ ምድብ ይምረጡ...',
  storeIsPackage: '📦 ይህ ጥቅል ነው',
  storePackageIntro: 'በዚህ ጥቅል ውስጥ የሚካተቱ ንዑሶችን ያክሉ፦',
  storePackageItemName: 'የንዑስ ስም',
  storePackageAddItem: '+ ወደ ጥቅሉ ንዑስ ጨምር',
  storeAvailableColors: 'ያለውት ቀለሞች',
  storeTapCircles: '(ለመምረጥ አንቀጾቹን ይጫኑ)',
  storeAllColors: '🎨 በሁሉም ቀለሞች ይገኛል',
  storeShowInBazaar: '🛍️ በሽያጭ ቦታ ውስጥ አሳይ',
  storeBazaarNote: '(በተዘጋጀው የሽያጭ ቦታ ጊዜነት ደግሞ ይያዛል — ምርቱ ሁልጊዜ በገበያ ገጽ ላይ ይታያል)',
  storeProductImages: 'የምርት ምስሎች *',
  storeUpToPhotos: '(እስከ 5 ፎቶዎች)',
  storeCurrentPhotos: 'አሁኑ ያሉ ፎቶዎች፦',
  storeUploadingPhotos: 'ፎቶዎች በመጫን ላይ...',
  storePackageBadge: 'ጥቅል',
  storeStockLabel: 'ክምት',
  storeAwaitingApproval: '⏳ የአስተዳዳሪ ምስጋት በመጠበቅ ላይ',

  subImgCountErr: 'በ3 እና 5 መካከል ምስሎች ይምረጡ።',
  subVidCountErr: 'በ3 እና 5 መካከል ቪዲዮዎች ይምረጡ።',
  subVidDurationErr: 'እያንዳንዱ ቪዲዮ ከ1 ደቂቃ በታች መሆን አለበት።',
  subNameRequired: 'እያንዳንዱ መንገድ ስም መግባት አለበት።',
  subPathImages: (name) => `"${name}": 3–5 ምስሎች ይምረጡ።`,
  subPathVideos: (name) => `"${name}": 3–5 ቪዲዮዎች ይምረጡ።`,
  subFixErrors: 'ከማስገባትዎ በፊት የፋይል ስህተቶችን እባክዎ አስተካክሉ።',
  subFailed: 'ማስገባት አልተቻለም። እባክዎ እንደገና ይሞክሩ።',
  subSuccessTitle: 'በተሳክቷል!',
  subSuccessMsg: 'ቡድናችን ይዘትዎን በግምገማ ላይ አስገባል፤ ከዚያ በኋላ እናገኝዎታለን።',
  subSubmitAnother: 'ሌላ ማስገባት አስገባ',
  subPageTitle: 'ይዘትዎን ያስገቡ',
  subPageIntro: 'ለእያንዳንዱ መንገድ የግዢ ይዘትዎን ይጫኑ።',
  subRules: '📋 ደንቦች፦ እያንዳንዱ መንገድ 3–5 ምስሎችና 3–5 ቪዲዮዎች ያስፈልጋል። እያንዳንዱ ቪዲዮ ከ1 ደቂቃ በታች መሆን አለበት።',
  subPathHeading: (n) => `መንገድ ${n}`,
  subRemove: 'አስወግድ',
  subPathName: 'የመንገድ ስም *',
  subPathNamePlaceholder: 'ለምሳሌ፦ የበጋኝ ዘመን እቅድ',
  subDescription: 'መግለጫ (አማራጭ)',
  subDescPlaceholder: 'የዚህ ይዘት አጭር መግለጫ...',
  subImagesLabel: 'ምስሎች (3–5) *',
  subImagesSelected: (n) => `✓ ${n} ምስሎች ተመርጠዋል`,
  subVideosLabel: 'ቪዲዮዎች (3–5፣ እያንዳንዱ ከ1 ደቂቃ በታች) *',
  subVideosSelected: (n) => `✓ ${n} ቪዲዮዎች ተመርጠዋል`,
  subAddPath: '+ ሌላ መንገድ አክል',
  subSubmitting: 'በማስገባት ላይ...',
  subSubmitPaths: (n) => `${n} መንገድ አስገባ`,
};